export default (fieldList) => {
  const obj = {}
  // 循环字段列表
  for (const item of fieldList) {
    const type = item.type === 'select' || item.type === 'cascader' || item.type === 'datePickerRange' || item.type === 'uploadPicture' ? '选择' : '输入'
    if (item.required) {
      if (item.validator) {
        obj[item.prop] = [{
          required: item.required,
          validator: item.validator,
          trigger: 'blur'
        }]
      } else {
        obj[item.prop] = [{
          required: item.required,
          message: '请' + type + item.label,
          trigger: 'blur'
        }]
      }
    } else if (item.validator) {
      obj[item.prop] = [{
        validator: item.validator,
        trigger: 'blur'
      }]
    }

    if (!obj[item.prop]) {
      obj[item.prop] = []
    }

    // console.log(obj[item.prop], 'obj[item.prop][0]')

    // if (item.type === 'select' || item.type === 'cascader') {
    //   if (obj[item.prop][0]) {
    //     obj[item.prop][0].trigger = 'change'
    //   }
    // }

    if (item.validateType) {
      obj[item.prop].push({
        message: item.validateTypeMassage,
        type: item.validateType,
        trigger: 'blur'
      })
    }

    if (item.max) {
      obj[item.prop].push({
        min: item.min,
        max: item.max,
        message: '长度在 ' + item.min + ' 到 ' + item.max + ' 个字',
        trigger: 'blur'
      })
    }
  }
  // console.log(obj, 'initrules')
  // formInfo.rules = obj
  return obj
}



// WEBPACK FOOTER //
// ./src/utils/initRules.js